module.exports = __webpack_public_path__ + "static/media/mockup-presentation.77a4c6a8.png";